import { useCallback, useEffect, useState } from 'react'
import { set as setCookie } from 'es-cookie'
import { track } from '@amplitude/analytics-browser'
import { listUserShopsService, switchShopService } from 'src/api/authentication'
import { getCookieOptions } from 'src/utils/cookie-options'

/**
 * Lists the user's workspaces and switches between them.
 * Switching stores the new tokens and reloads the app at `redirectTo`.
 */
const useWorkspaces = () => {
  const [workspaces, setWorkspaces] = useState([])
  const [currentWorkspace, setCurrentWorkspace] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    listUserShopsService()
      .then(res => {
        if (res.data && res.data.length > 0) {
          setWorkspaces(res.data)
          setCurrentWorkspace(
            res.data.find(shop => shop.isCurrentShop) || res.data[0],
          )
        }
      })
      .catch(err => {
        console.error('Failed to fetch workspaces', err)
      })
      .finally(() => {
        setLoading(false)
      })
  }, [])

  const switchWorkspace = useCallback(
    (shopId, redirectTo = '/') => {
      const targetWorkspace = workspaces.find(w => w.shopId === shopId)

      return switchShopService(shopId)
        .then(res => {
          const user = res.data
          if (user && user.accessToken) {
            track('workspace_change', {
              step: 'success',
              from_shop_id: currentWorkspace?.shopId || null,
              from_shop_name: currentWorkspace?.shopName || null,
              to_shop_id: targetWorkspace?.shopId || shopId,
              to_shop_name: targetWorkspace?.shopName || null,
            })
            setCookie('token', user.accessToken, getCookieOptions())
            setCookie('refreshToken', user.refreshToken, getCookieOptions())
            setCookie('userId', user.userId, getCookieOptions())
            window.location.href = redirectTo
          }
        })
        .catch(err => {
          console.error('Failed to switch workspace', err)
        })
    },
    [workspaces, currentWorkspace],
  )

  return { workspaces, currentWorkspace, loading, switchWorkspace }
}

export default useWorkspaces
